// extracted by mini-css-extract-plugin
export default {"productDescription":"z_-z","featuredDescription":"A_-z","description":"B_-z","more":"C_-z","descriptionSku":"D_-z"};